<template lang="pug">
    v-autocomplete(dense 
        v-model="dataPayType" 
        :disabled="disabled"
        :readonly="readonly" 
        :label="label" 
        :rules="rules"
        :items="listData" 
        :item-text="text" 
        item-value="payType" 
        @change="onSelect" 
        :required = "required")
</template>
<script>
export default {
    name: "FSelectPayType",
    props: [
        "value",
        "disabled",
        "readonly",
        "label",
        "rules",
        "required",
        "mapId",
        "payTypeData"
    ],
    data() {
        return {
            dataPayType: {},
            listData: []
        }
    },
    mounted() {
        this.doInit(this.value);
    },
    watch: {
        value(val){
            this.doInit(val);
        },
        mapId(val){
            this.doLoad();
        },
        payTypeData(val){
            this.listData = val || [];
        }
    },
    methods: {
        text: item => item.payType + " - " + item.description,
        doInit(values){
            this.doLoad();
            this.dataPayType = values ? values : null;
            this.onSelect();
        },
        doLoad(){
            if (this.mapId && !this.payTypeData) {
                this.$http.get("/api/parameter/pay-type-tax-by-map/" + this.mapId).then(success => {
                    this.listData = success.data;
                });
            }else{
              this.listData=this.payTypeData;
            }
        },
        onSelect() {
            this.$emit("input", this.dataPayType);
            this.$emit("select", this.dataPayType);
            this.$emit("payType", this.valueData());
        },
        valueData(){
            let result = null;
            this.listData.map(element => {
                if (this.dataPayType === element.payType) {
                    result = element;
                }
            });
            return result;
        },
    },
}
</script>